<template>
  <div>
        <ui-modal
            :shown="shown"
            id="lightbox-photo-guidelines"
            no-cancel
            no-confirm
            :handle-close="close"
        >
            <template #header>
                <div>
                    <h5 class="mb-3 text-center">{{ pageTitle }}</h5>
                    <div class="tabs container my-0 px-0" role="tablist">
                        <ul class="tabs__list">
                            <li v-for="tab in tabs" :key="tab" class="tabs__item tabs__item--summary" :class="{ 'active': activeTab === tab }" role="presentation">
                            <a
                                href="#"
                                @click.prevent="setActiveTab(tab)"
                                class="tabs__link"
                                role="tab"
                            >
                                {{ getTabTitle(tab) }}
                            </a>
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
            <template #body>
                <div :key="activeTabType">
                    <slot :name="activeTabType"></slot>
                </div>
            </template>
        </ui-modal>
  </div>
</template>

<script>
import { NUDITY_CLASSIFICATION, NUDITY_CLASSIFICATION_TYPE_MAP, NUDITY_CLASSIFICATION_TEXT_MAP } from '../constants';
import { getLightboxName } from '../utils';

export default {
  name: 'LightboxPhotoGuidelines',
  components: {
        UiModal: () => import(/* webpackChunkName: "chunk-ui-modal" */ './ui/ui-modal.vue'),
    },
    data() {
        return {
            lightboxName: null,
            tabs: Object.values(NUDITY_CLASSIFICATION).filter(tab => tab !== NUDITY_CLASSIFICATION.UNIDENTIFIED),
            activeTab: NUDITY_CLASSIFICATION.SAFE,
            pageTitle: gettext("Photo guidelines"),
        }
    },
    computed: {
        shown() {
            return this.$store.getters['ui/lightboxManager/lightboxIsShown'](this.lightboxName);
        },
        activeTabType() {
            return NUDITY_CLASSIFICATION_TYPE_MAP[this.activeTab];
        }
    },
    mounted() {
        this.lightboxName = getLightboxName({ el: this.$el });
    },
    methods: {
        getTabTitle(tab) {
            return NUDITY_CLASSIFICATION_TEXT_MAP[tab];
        },
        setActiveTab(tab) {
            this.activeTab = tab;
        },
        close() {
            this.$store.dispatch("ui/lightboxManager/hide", this.lightboxName);
        }
    }
};
</script>
